import React from "react";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";

import { CompanySettingsPage } from "../../pages/settings/";
import { customerArticlesResource } from "../../resources/customer-articles";
import { pricelistArticlesResource } from "../../resources/customer-pricelist-articles";
import { customerUsers } from "../../resources/customer-users";
import { deviationsResource } from "../../resources/deviations";
import { deviationsRoutes } from "../../resources/deviations/deviations_routes";
import { customerDriversResource } from "../../resources/drivers/";
import { inventoryListResource } from "../../resources/inventory-list";
import Messages from "../../resources/messages/List/List";
import { ordersByAPIResource } from "../../resources/orders-by-api";
import {
	OrderCreateByCustomer,
	OrderEditByCustomerTransporter,
	OrderShowTabsWrapper,
	ordersDraftResource,
	ordersResource,
} from "../../resources/orders/";
import { OrdersMultipleChangesPage } from "../../resources/orders/MultipleChanges2";
import { pricelistHolidaysResource } from "../../resources/pricelist-holidays/";
import { readonlyThirdPartyAppsResource } from "../../resources/third-party-apps";
import { transportTrailersResource } from "../../resources/trailers";
import { transportTrucksResource } from "../../resources/trucks";
import { authenticatedResources } from "./authenticated";

export const customerAndTransporterManagerResources = [
	<Resource
		{...ordersResource}
		edit={OrderEditByCustomerTransporter}
		create={OrderCreateByCustomer}
		show={OrderShowTabsWrapper}
		options={{ label: "Orders" }}
		name="orders"
	/>,
	<Resource
		name="draft-orders"
		{...ordersDraftResource}
		edit={OrderEditByCustomerTransporter}
		show={OrderShowTabsWrapper}
	/>,
	<Resource name="orders-by-api" {...ordersByAPIResource} />,
	<Resource {...deviationsResource} name="deviations" />,

	// <Resource {...customersEmployeesResource} name="customer-employees" />,
	<Resource {...customerUsers} name="customer-users" options={{ label: "Employees" }} />,
	// <Resource {...transportersResource} create={null} edit={null} name="transporters" />,
	<Resource {...transportTrucksResource} name="trucks" />,
	<Resource {...transportTrailersResource} name="trailers" />,
	<Resource name="drivers" {...customerDriversResource} />,
	<Resource
		{...pricelistArticlesResource}
		name="customer-pricelist-articles"
		options={{ hasUpload: false }}
	/>,
	<Resource {...pricelistHolidaysResource} name="pricelist-holidays" />,
	<Resource {...customerArticlesResource} name="customer-articles" />,
	<Resource name="ports" intent="registration" />,
	<Resource name="areas" intent="registration" />,
	<Resource name="users" intent="registration" />,
	<Resource name="customer-companies" intent="registration" />,
	<Resource name="mappers" intent="registration" />,
	<Resource name="company-notifications" intent="registration" />,
	<Resource name="order-statuses" intent="registration" />,
	<Resource name="deviation-statuses" intent="registration" />,
	<Resource name="outgoing-doc-statuses" intent="registration" />,
	<Resource name="cooler-types" intent="registration" />,
	<Resource name="order-pricelist" intent="registration" />,
	<Resource name="order-history" intent="registration" />,
	<Resource name="transporters" intent="registration" />,
	<Resource name="storage-places" intent="registration" />,
	<Resource name="storage-places-lookup" intent="registration" />,
	<Resource name="terminal" intent="registration" />,
	<Resource name="external-terminal-links" intent="registration" />,
	<Resource name="company-users" intent="registration" />,
	<Resource name="commodities" intent="registration" />,
	<Resource name="pallets-and-boxes" intent="registration" />,
	<Resource name="pallets" intent="registration" />,

	<Resource name="custom-fields" intent="registration" />,
	<Resource name="product-articles" intent="registration" />,
	<Resource name="order-product-articles" intent="registration" />,
	<Resource name="product-numbers" intent="registration" />,
	<Resource name="product-names" intent="registration" />,
	<Resource name="automatic-pallets-reservation" intent="registration" />,
	<Resource name="inventory-list" {...inventoryListResource} />,
	<Resource name="third-party-apps" {...readonlyThirdPartyAppsResource} />,
	...authenticatedResources,
];

export const customerAndTransporterManagerRoutes = [
	deviationsRoutes.edit,
	<Route exact path="/messages" component={Messages} />,
	<Route exact path="/notifications" component={CompanySettingsPage} />,
	<Route exact path="/orders/multiple-changes" component={OrdersMultipleChangesPage} />,
	<Route exact path="/draft-orders/multiple-changes" component={OrdersMultipleChangesPage} />,
];
